module.exports = __webpack_public_path__ + "img/logo.802d961b.svg";